module.exports = __webpack_public_path__ + "static/media/dhl-logo-black-and-white.905a9e61.png";